import Component from '../classes/Component';

export default class HeadingsAnimation extends Component {
	constructor() {
		super({
			element: 'main',
			elements: {
				headings: '.u-text-heading',
			},
		});

		this.createObserver();
	}

	createObserver() {
		this.observer = new IntersectionObserver(
			entries => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add('active');
					}
				});
			},
			{ rootMargin: '0px 0px -5% 0px' },
		);
		this.elements.headings.forEach(heading => {
			this.observer.observe(heading);
		});
	}
}
